import { StockInfo } from '@pedix-workspace/shared-stock';
import {
  CouponValidationErrorCode,
  Establishment,
  EstablishmentClosedReason,
  HiddenProduct,
  PricingError,
  PurchaseRestrictionViolation,
  TypesOfShippings,
} from '@pedix-workspace/utils';

export function isEstablishmentClosedError(
  error: unknown,
): error is {
  details: {
    reason?: EstablishmentClosedReason;
    workingDays: Establishment['workingDays'];
    temporaryClosure?: Establishment['temporaryClosure'];
  };
} {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.workingDays;
}

export function isOrderNotFoundError(error: unknown): error is Error {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.code === 'functions/not-found';
}

export function isOrderStockError(
  error: unknown,
): error is { details: { stockErrors: StockInfo[] } } {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.stockErrors;
}

export function isOrderPricingError(
  error: unknown,
): error is { details: { pricingErrors: PricingError[] } } {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.pricingErrors;
}

export function isProductHiddenError(
  error: unknown,
): error is { details: { hiddenProducts: HiddenProduct[] } } {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.hiddenProducts;
}

export function isProductRestrictionError(
  error: unknown,
): error is { details: { restrictedProducts: PurchaseRestrictionViolation[] } } {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.restrictedProducts;
}

export function isShippingPaymentNotAllowedError(error: unknown): error is {
  details: { shippingPaymentNotAllowed: { shippingOptionType: TypesOfShippings; paymentMethodValue: string } };
} {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.shippingPaymentNotAllowed;
}

export function isShippingOptionNotAvailableError(error: unknown): error is {
  details: { shippingOptionNotAvailable: { shippingOptionType: TypesOfShippings } };
} {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return Boolean(
    (error as { details?: { shippingOptionNotAvailable?: unknown } })?.details
      ?.shippingOptionNotAvailable,
  );
}

export function isCouponValidationError(
  error: unknown,
): error is { details: { couponValidationErrorCode: CouponValidationErrorCode } } {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  return (error as any)?.details?.couponValidationErrorCode;
}

export function isPromotionConditionsChangedError(
  error: unknown,
): error is { details: { promotionConditionsChanged: true; clientDiscount: number; serverDiscount: number } } {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  const details = (error as any)?.details;
  return (
    details?.promotionConditionsChanged === true &&
    typeof details?.clientDiscount === 'number' &&
    typeof details?.serverDiscount === 'number'
  );
}
